<template>
  <div class="container home-page">
    <!--  <HelloWorld msg="Welcome to visit"/> -->
    <transition name="fade">
      <div :class="indexShow == true ? 'header' : 'invisitListHeader' " class="container">
        <div class="header-agent row" v-show="indexShow">
          <div class="set-agent col-8" v-if="this.userType === '1'">
            <div>
              <router-link to="/agent">
                <img src="../assets/images/character-mind.png">
                <span>{{$t('setAgent')}}<i class="iconfont icon-right"></i></span>
              </router-link>
            </div>
          </div>
          <selectLanguage
            :isShow="true"
            :isExternal="false"
            :userType="Number(userType)"
            :url="setlanguage"
          />
        </div>
        <div class="content row">
          <div class="right col-9">
            <img class="photo" :src="this.avatar" alt="photo">
            <div class="header-title">
              <div class="homeName">{{$t('systemName')}}</div>
              <div class="departmentName">{{indexData.userName}}（{{indexData.deptName}}）</div>
            </div>
          </div>
          <div class="col-3 right-log">
            <img class="logo" alt="Logo" width="300" src="../assets/images/logo.png">
          </div>
        </div>
      </div>
    </transition>
    <div class="container messageBoxHeader">
      <div v-show="indexShow" class="messageBox">
        <div @click="showUnReadList = !showUnReadList" class="notifications">
          <div class="msg-tip">
            <i class="iconfont icon-speaker"></i><span>{{unReadListLength}}</span>{{$t('invitedNumber')}}
          </div>
          <i class="iconfont icon-right"></i>
        </div>
        <transition name="slide-fade">
          <div class="messageDown" v-if="unReadListLength" v-show="showUnReadList">
            <div class="messageList">
              <ul>
                <li v-for="(item, index) in unReadList" :id="'msg-' + item.messageId"  @click="clearSingle" :data-id="item.messageId" :data-url="item.url">
                  <div class="status-line row">
                    <div class="col-12 msg-status"><span class="radius-list"></span>{{item.title}}</div>
                    <div class="col-12 msg-date">{{item.createTime}}</div>
                  </div>
                  <div class="messageContent">
                    {{item.message}}
                  </div>
                </li>
              </ul>
            </div>
            <div class="clearAll" @click="clearAll">
              <span>{{$t('empty')}}</span>
            </div>
          </div>
        </transition>
      </div>
    </div>
   <div v-show="indexShow" class="container">
    <div class="invisitList-top">
      <div class="invisitList">
        <div class="row four-row">
          <div class="col-3" v-on:click="newVisitShow">
           <div>
              <img src="../assets/images/add@2x.png">
            </div>
            <div>
               <p>{{$t('newInvitation')}}</p>
            </div>
          </div>
          <div class="col-3" v-on:click="visitListShow">
           <div>
              <img src="../assets/images/list@2x.png">
            </div>
            <div>
              <p>{{$t('invitationList')}}</p>
            </div>
          </div>
          <div class="col-3" @click="visitListWarehouseShow">
           <div>
              <img src="../assets/images/dispatcher@2x.png">
            </div>
            <div>
               <p>{{$t('consigneeOrConsignor')}}</p>
            </div>
          </div>
          <div class="col-3" @click="visitListCCShow">
           <div>
              <img src="../assets/images/cc@2x.png">
            </div>
            <div>
               <p>{{$t('ccList')}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="visit-count" v-if="visitSituation !== null">
      <dl class="row">
        <dt>{{$t('regionalAccessStatisticsArea')}}{{$t('regionalAccessStatistics')}}</dt>
        <dd>{{$t('Planned')}}({{visitSituation.planCount}})</dd>
        <dd>{{$t('Visited')}}({{visitSituation.visitCount}})</dd>
        <dd>{{$t('Visiting')}}({{visitSituation.notleavingCount}})</dd>
      </dl>
    </div>
     
    <div class="invisitList-wait-today">
     <!--  <checkMessage /> -->
      <indexMessageList @getModalMessage="showModal" @getType="changeType"/>
    </div>
   </div>
   <transition name="fade">
     <div class="visit-show" v-show="this.invisitListShow" >
      <div>
<!--         <invisitList v-if="this.userType === 'gm'" @getMessage="getVal" :visitList="this.visitListGM"></invisitList>
        <invisitList v-else-if="this.userType === 'warehouse'" @getMessage="getVal" :visitList="this.visitListWarehouse"></invisitList>
        <invisitList v-else @getMessage="getVal" :visitList="this.visitListGeneral"></invisitList> -->
        <invisitList @getVisitListType="changeType"  @getMessage="getVal" :visitListType="this.visitListType" :tabs="this.tabs"></invisitList>
      </div>
     </div>
   </transition>
   <transition name="fade">
     <div class="visit-show" v-show="this.newinvisitShow">
      <div>
        <newInvisit @getMessage="getInvisitModal" ></newInvisit>
      </div>
     </div>
   </transition>
    <transition name="fade">
      <div class="tip" v-show="this.modalTip">
        <div class="tip-inner">
          <div class="tip-text">{{modalTipText}}</div>
          <div class="comfirmBtn" @click="modalTip = !modalTip">{{$t('confirm')}}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import { API } from '@/config/config';
import HelloWorld from '@/components/HelloWorld.vue';
import indexMessageList from '@/components/indexMessageList.vue';
import invisitList from '@/components/invisitList.vue';
import newInvisit from '@/components/newInvisit.vue';
import selectLanguage from '@/components/selectLanguage.vue';
import myAuth from '@/utils/auth';
import { getUserInfo, getUnReadList, setRead, setSingleRead, getVisitSituation } from '@/utils/api';
import { checkNested } from '@/utils/utils';
import $ from 'jquery';

export default {
  name: 'home',
  components: {
    HelloWorld,
    indexMessageList,
    invisitList,
    newInvisit,
    selectLanguage,
  },
  data() {
    return {
      setlanguage: API.setlanguage,
      indexShow: true,
      messageList: false,
      indexData: '',
      arrorRight: require('../assets/images/arrow-copy.png'),
      unReadList: [],
      unReadListLength: 0,
      showUnReadList: false,
      modalTip: false,
      modalTipText: '',
      sendInvisit: false,
      invisitListShow: false,
      newinvisitShow: false,
      userType: '',
      visitListType: '',
      tabs: {},
      checkTabs: {
        tabs: [
          {
            active: 'active',
            name: this.$t('waitingApproval'),
          },
          {
            active: '',
            name: this.$t('approved'),
          },
        ],
        subTabs: [
          {
            active: 'active',
            name: this.$t('all'),
          },
          {
            active: '',
            name: this.$t('approver'),
          },
          {
            active: '',
            name: this.$t('creatorWitoutColon'),
          },
        ],
      },
      todayTabs: {
        tabs: [
          {
            active: 'active',
            name: this.$t('before'),
          },
          {
            active: '',
            name: this.$t('Ongoing'),
          },
          {
            active: '',
            name: this.$t('past'),
          },
        ],
        subTabs: [

        ],
      },
      allTabs: {
        tabs: [
          {
            active: 'active',
            name: this.$t('before'),
          },
          {
            active: '',
            name: this.$t('Ongoing'),
          },
          {
            active: '',
            name: this.$t('past'),
          },
        ],
        subTabs: [
          {
            active: 'active',
            name: this.$t('all'),
          },
          {
            active: '',
            name: this.$t('creatorWitoutColon'),
          },
          {
            active: '',
            name: this.$t('approver'),
          },
        ],
      },
      ccTabs: {
        tabs: [
          {
            active: 'active',
            name: this.$t('before'),
          },
          {
            active: '',
            name: this.$t('Ongoing'),
          },
          {
            active: '',
            name: this.$t('past'),
          },
        ],
        subTabs: []
      },
      warehouseTabs: {
        tabs: [
          {
            active: 'active',
            name: this.$t('today'),
          },
          {
            active: '',
            name: this.$t('tomorrow'),
          },
          {
            active: '',
            name: this.$t('next'),
          },
        ],
        subTabs: [
          {
            active: 'active',
            name: this.$t('all'),
          },
          {
            active: '',
            name: this.$t('receive')
          },
          {
            active: '',
            name: this.$t('send')
          }
        ]
      },
      visitSituation:{},
      avatar: require('../assets/images/default-avatar.png'),
    }
  },
  created: function () {
    this.indexShow = this.$route.query.invisit == 'true' ? false : true;
    this.invisitListShow = this.$route.query.invisit == 'true' ? true : false;
    getUserInfo().then(res => {
      //console.log(res);
      if (checkNested(res, 'data', 'content', 'model')) {
        this.indexData = res.data.content.model;
        const avatar = this.indexData.avatar;
        this.avatar = avatar == '' ? this.avatar : avatar;
      }
    });
    this.userType = myAuth.getLocalUserRole();
    this.getMsgList();
    this.getVisitSituationIndex();
  },
  methods: {
    getMsgList: function() {
      getUnReadList().then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          this.unReadList = res.data.content.model;
          this.unReadListLength = this.unReadList.length;
        }
      });
    },
    clearSingle: function(e) {
      const target = e.currentTarget;
      const url = target.dataset.url;
      setSingleRead(target.dataset.id).then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          if (url != null) {
            window.location.href = url;
          }
          this.getMsgList();
        }
      });
    },
    clearAll: function() {
      setRead().then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          this.modalTip = true;
          this.modalTipText = res.data.content.message;
        }
        this.getMsgList();
      });
    },
    getVisitSituationIndex: function() {
      getVisitSituation().then((res) => {
        if (checkNested(res, 'data', 'content', 'model')) {
          this.visitSituation = res.data.content.model;
        }
      });
    },
    visitListShow: function() {
      var tabs = {};
      this.invisitListShow = true;
      this.indexShow = false;
      this.visitListType = 'all';
      this.copyArr(this.allTabs, tabs);
      this.tabs = tabs;
    },
    visitListCCShow: function() {
      var tabs = {};
      this.invisitListShow = true;
      this.indexShow = false;
      this.visitListType = 'cc';
      this.copyArr(this.ccTabs, tabs);
      this.tabs = tabs;
    },
    visitListWarehouseShow: function() {
      var tabs = {};
      this.invisitListShow = true;
      this.indexShow = false;
      this.visitListType = 'warehouse';
      this.copyArr(this.warehouseTabs, tabs);
      this.tabs = tabs;
    },
    showModal: function (msg) {
      this.invisitListShow = msg;
      this.indexShow = false;
    },
    getVal: function (msg) {
      this.invisitListShow = msg;
      this.indexShow = true;
    },
    newVisitShow: function () {
      this.newinvisitShow = true;
      this.indexShow = false;
    },
    getInvisitModal: function (msg) {
      this.newinvisitShow = msg;
      this.indexShow = true;
    },
    changeType: function (type) {
      var tabs = {};
      let newTabs = type == 'check' ? this.checkTabs : this.todayTabs;
      this.visitListType = type;
      this.copyArr(newTabs, tabs);
      this.tabs = tabs;
    },
    copyArr: function(p, c){
      var c = c || {};
      for (var i in p) {
        if (typeof p[i] === "object") {
          c[i] = (p[i].constructor === Array) ? [] : {};
          this.copyArr(p[i], c[i]);
        } else {
          c[i] = p[i]
        }
      }    
      return c;
    }
  }

};
</script>

<style  lang="scss">
  @import "../scss/variables.scss";
  body,
  ul,
  li,
  h1,
  div{
    margin: 0;
    padding: 0;
  }
  body {
    background-color: rgba(57, 74, 84, 0.08);
  }
  #app {
    background-color: #fff;
  }
  .form-control:focus {
    box-shadow: none;
  }
  .header {
    width: 100%;
    height: 158px;
    background: url('../assets/images/rectangle-copy-8@2x.png') no-repeat;
    background-size: 100% 100%;
    .header-agent {
      width: 90%;
      margin: auto;
      padding: 15px 0;
      div {
        padding: 0;
      }
      .set-agent {
        div {
          width: 120px;
          height: 25px;
          line-height: 25px;
          border-radius: 10px;
          text-align: center;
          background: rgba(0, 0, 0, 0.15);
          font-size: 0;
          vertical-align: top;
          img {
            width: 15px;
            height: 17px;
            vertical-align: middle;
          }
          span {
            font-family: HiraginoSansGB-W3;
            font-size: 11px;
            color: #fff;
            vertical-align: middle;
            padding-left: 8px;
          }
          i {
            padding-left: 8px;
            color: #fff;
            font-size: 12px;
            display: inline-block;
            transform: scale(0.65, 0.65);
          }
        }
        a:hover {
          text-decoration: none;
        }
      }
    }
    .content {
      display: flex;
      width: 90%;
      margin: auto;
      .right-log {
        padding: 0;
      }
      .logo {
        width: 30%;
        height: 35%;
        float: right;
        padding: 0;
        padding-top: 7px;
        @include respond-to('xs') {
           width: 100%;
           height: auto;
        }
        @include respond-to('md') {
           width: 90%;
           height: auto;
           padding: 0;
        }
        @include respond-to('lg') {
           width: 60%;
           height: auto;
           padding: 0;
        }
      }
      .photo {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        padding: 0;
      }
      .right {
        display: flex;
        padding: 0;
        .header-title {
          padding-left: 15px;
        }
        div {
          color: #fff;
          line-height: 26px;
          &:first-child {
            // font-family: HiraginoSansGB-W6;
            font-size: 18px;
          }
          &:last-child {
            // font-family: HiraginoSansGB-W3;
            font-size: 13px;
          }
        }
      }
    }
  }
  .invisitListHeader {
    width: 100%;
    height: 158px;
    background-image: -webkit-linear-gradient(335deg, #f36443, #e42029), 
    -webkit-linear-gradient(290deg, #f36443, #ab272d);
    border-radius: 0 0 21px 21px;
    .header-agent {
      width: 90%;
      margin: auto;
      padding: 15px 0;
      div {
        padding: 0;
      }
      & > div:first-child {
        div {
          width: 105px;
          height: 25px;
          line-height: 25px;
          border-radius: 10px;
          text-align: center;
          background: rgba(0, 0, 0, 0.15);
          font-size: 0;
          vertical-align: top;
          img {
            width: 15px;
            height: 17px;
            vertical-align: middle;
          }
          span {
            font-family: HiraginoSansGB-W3;
            font-size: 11px;
            color: #fff;
            vertical-align: middle;
            padding-left: 8px;
          }
          i {
            padding-left: 8px;
            color: #fff;
          }
        }
      }
      & > div:last-child {
        text-align: right;
        select {
          color: #fff;
          appearance: none;
          border: none;
          outline: none;
          padding-right: 13px;
          background: url('../assets/images/arrow-copy-white.png') no-repeat right center;
          background-size: 10px;
          option {
            background: #ccc;
          }
        }
      }
    }
    .content {
      display: flex;
      width: 90%;
      margin: auto;
      padding-top: 25px;
      .right-log {
        padding: 0;
      }
      .logo {
        width: 30%;
        height: 35%;
        float: right;
        padding: 0;
        padding-top: 7px;
        @include respond-to('xs') {
           width: 100%;
           height: auto;
        }
        @include respond-to('md') {
           width: 90%;
           height: auto;
           padding: 0;
        }
        @include respond-to('lg') {
           width: 60%;
           height: auto;
           padding: 0;
        }
      }
      .photo {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        padding: 0;
      }
      .right {
        display: flex;
        padding: 0;
        .header-title {
          padding-left: 15px;
        }
        div {
          color: #fff;
          line-height: 26px;
          &:first-child {
            // font-family: HiraginoSansGB-W6;
            font-size: 18px;
          }
          &:last-child {
            // font-family: HiraginoSansGB-W3;
            font-size: 13px;
          }
        }
      }
    }
  }
  .messageBoxHeader {
    position: absolute;
  }
  .messageBox {
    width: 90%;
    margin: auto;
    position: absolute;
    left: calc(100%/2 - 90%/2);
    i {
      vertical-align: middle;
    }
    .notifications {
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 45px;
      line-height: 45px;
      align-items: center;
      margin: 0 auto;
      margin-top: -22.5px;
      padding: 15px 18px 15px 20px;
      border-radius: 6px;
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.07);
      background-color: #ffffff;
      cursor: pointer;
      .msg-tip {
        vertical-align: middle;
        color: #394a54;
        font-size: 12px;
        line-height: 20px;
        img {
          width: 20px;
          height: 20px;
          vertical-align: middle;
          margin-right: 10px;
        }
        span {
          color: #e42029;
          font-size: 12px;
        }
        i {
          font-weight: bold;
          margin-right: 10px;
        }
      }
      .icon-right {
        font-size: 12px;
        color: #394a54;
      }
    }
    .messageDown {
      position: absolute;
      width: 100%;
      z-index: 2;
    }
    .messageList {
      width: 100%;
      max-height: 234px;
      border-radius: 6px;
      box-shadow: 0 0 25px rgba(100, 100, 100, 0.3);
      background-color: #ffffff;
      position: relative;
      margin-top: 20px;
      padding-top: 10px;
      padding-bottom: 29px;
      &:before {
        content: '';
        position: absolute;
        top: -7px;
        right: 25px;
        width: 15px;
        height: 15px;
        background: #fff;
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
      }
      ul {
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 195px;
        li {
          list-style: none;
          line-height: 28px;
          border-bottom: 1px dashed #ddd;
          padding: 10px 12px;
          &:first-child {
            padding-top: 0;
          }
          &:last-child {
            border-bottom: none;
          }
          .status-line {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;
            align-items: flex-start;
          }
          .msg-status {
            color: #e42029;
            font-size: 14px;
            font-weight: bold;
          }
          .msg-date {
            font-size: 11px;
            color: #929292;
            line-height: 20px;
            text-align: right;
          }
          .radius-list {
            display: inline-block;
            margin-right: 8px;
            vertical-align: middle;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #ff2137;
            border: 3px solid #ffe2ef;
          }
          .messageContent {
            font-size: 14px;
            color: #4a4a4a;
            line-height: 20px;
          }
        }
      }
    }
    .clearAll {
      position: relative;
      z-index: 2;
      width: 100px;
      height: 36px;
      border-radius: 21px;
      background-image: linear-gradient(68deg, #f36443, #e42029);
      line-height: 36px;
      text-align: center;
      margin: 0 auto;
      margin-top: -20px;
      span {
        font-size: 15px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
  .invisitList {
    width: 90%;
    margin: auto;
    margin-top: 60px;
    .four-row {
      padding: 0;
      div {
        text-align: center;
        padding: 0;
        img {
          width: 45%;
          @include respond-to('md') {
             width: auto;
          }
        }
        p {
          text-align: center;
          // font-family: HiraginoSansGB-W6;
          font-size: 14px;
          font-weight: bold;
        }
        & > div:first-child {
          padding-bottom: 15px;
        }
      }
      & > div:first-child,
      & > div:last-child {
        left: -15px;
        position: relative;
      }
      & > div:last-child {
        left: 15px;
        right: -15px;
      }
    }
    & > div {
      width: 100%;
      padding: 0 15px;
      margin: 0;
      div.col-6 {
        position: relative;
        border-radius: 6px;
        box-shadow: 0 9px 15px 0 rgba(0, 0, 0, 0.03);
        background-color: #fff;
        padding: 0;
        text-align: center;
        &:first-child,
        &:last-child {
          -left: -15px;
          position: relative;
          div:first-child {
            padding: 30px 0;
            p {
              margin: 0;
              line-height: 30px;
              &:first-child {
                // font-family: HiraginoSansGB-W6;
                font-size: 16px;
                color: #4a4a4a;
              }
              &:last-child {
                // font-family: HiraginoSansGB-W6;
                font-size: 12px;
                color: #929292;

              }
            }
          }
          div:last-child {
            position: absolute;
            bottom: -30px;
            left: 50%;
            transform: translate(-50%, 0);
            img {
              width: 60%;
            }
          }
        }
        &:last-child {
          -left: 15px;
          -right: -15px;
        }
      }
      div.col-4 {
        position: relative;
        border-radius: 6px;
        box-shadow: 0 9px 15px 0 rgba(0, 0, 0, 0.03);
        background-color: #fff;
        padding: 0;
        text-align: center;
        &:first-child,
        &:nth-of-type(2),
        &:last-child {
          left: -15px;
          div:first-child {
            padding: 30px 0;
            p {
              margin: 0;
              line-height: 30px;
              &:first-child {
                // font-family: HiraginoSansGB-W6;
                font-size: 16px;
                color: #4a4a4a;
              }
              &:last-child {
                // font-family: HiraginoSansGB-W6;
                font-size: 12px;
                color: #929292;
              }
            }
          }
          div:last-child {
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translate(-50%, 0);
            img {
              width: 60%;
            }
          }
        }
        &:nth-of-type(2) {
          left: 0;
        }
        &:last-child {
          left: 15px;
          right: -15px;
        }
      }
    }
  }
  .visit-show {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top:0;
    z-index: 10;
    background:rgba(0, 0, 0, 0.4);
    .invisitListContent {
      position: absolute;
      bottom: 0;
    }
  }
  .invisitList-wait-today {
    width: 100%;
    margin: auto;
    padding-top: 30px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all 0.5s ease;
  }
  .fade-enter, .fade-leave-active /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .invisitList-top {
    width: 100%;
    background-color: #fff;
    box-shadow: 0 10px 25px rgba(100,100,100,.06);
  }
  .home-page {
    .tip {
      width: 100%;
      height: 100%;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 9999;
      background: rgba(0, 0, 0, 0.4);
      .tip-inner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 270px;
        border-radius: 12px;
        background-color: #fcfcfc;
        text-align: center;
        .tip-text {
          padding: 20px 0 15px;
          font-size: 17px;
          color: #4a4a4a;
        }
        .comfirmBtn {
          padding: 12px;
          font-size: 17px;
          color: #e42029;
          display: block;
        }
      }
      .icon-close {
        position: absolute;
        top: 10px;
        right: 5%;
        z-index: 10;
        font-size: 22px;
      }
    }
  }
  .visit-count {
    width: 90%;
    margin: 30px auto 0;
    dl {
      margin-bottom: 0;
      justify-content: space-between;
    }
    dt,
    dd,
    de{
      font-size: 12px;
      color: #929292;
      margin-bottom: 0;
    }
    dt {
      padding: 0 12px;
      padding-right: 0;
    }
    de {
      padding: 0 12px 0 0;
    }
    dd{
      text-align: left;
    }
  }
</style>
